var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled, { css } from 'styled-components';
import { buildBorderProps, buildColorProps, buildPaddingProps, buildSpacingProps, } from '../../helpers/builders';
export var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  p {\n    padding: 0;\n    margin: 0;\n    line-height: 100% !important;\n  }\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n"], ["\n  p {\n    padding: 0;\n    margin: 0;\n    line-height: 100% !important;\n  }\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n"])), buildColorProps, buildBorderProps, buildSpacingProps, function (_a) {
    var variant = _a.variant, bWidth = _a.bWidth, props = __rest(_a, ["variant", "bWidth"]);
    if (variant === 'light') {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), buildPaddingProps(props, function (p) { return p - (bWidth ? props.theme.borderWidth[bWidth] : 0); }));
    }
    return '';
});
var templateObject_1, templateObject_2;
